import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import {
  ButtonComponent,
  DashboardCardComponent,
  DashboardCardFooterDirective,
  DashboardCardHeaderActionsDirective,
  EmptyPlaceholderActionsDirective,
  EmptyPlaceholderComponent,
} from '@catch/general-ui';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faBriefcase,
  faChevronRight,
  faSearch,
} from '@fortawesome/pro-light-svg-icons';
import { TranslocoPipe } from '@jsverse/transloco';
import { PlatformDashboardService } from '../../../../services/platform-dashboard.service';
import { PlatformDashboardApplicationItemComponent } from '../dashboard-application-item/platform-dashboard-application-item.component';

@Component({
  selector: 'app-platform-dashboard-applications',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    ButtonComponent,
    DashboardCardComponent,
    DashboardCardFooterDirective,
    DashboardCardHeaderActionsDirective,
    EmptyPlaceholderActionsDirective,
    EmptyPlaceholderComponent,
    FontAwesomeModule,
    TranslocoPipe,
    PlatformDashboardApplicationItemComponent,
  ],
  templateUrl: './platform-dashboard-applications.component.html',
  styleUrl: './platform-dashboard-applications.component.scss',
})
export class PlatformDashboardApplicationsComponent {
  readonly dashboard = inject(PlatformDashboardService);
  readonly icons = {
    briefcase: faBriefcase,
    chevronRight: faChevronRight,
    search: faSearch,
  };

  readonly discoverJobsLink = computed(() =>
    this.dashboard.hasJobRecommendations() ? ['/jobs'] : ['/']
  );
}
